import React from "react";
import './ProgressBar.scss';

// Generic value/target progress bar, structured the same way as BmiBar
// (native range input + value/unit label) but with no domain-specific
// meaning. Renders "{value}/{maxValue}" grouped on the left (the "/" is
// automatic, not something the caller types) and the computed percent
// on the right. Pass `unit` for optional extra text after the fraction
// (e.g. "คะแนน").
const ProgressBar = ({
    value,
    minValue = 0,
    maxValue = 300,
    unit,
    showTarget = true,
    showPercent = true,
    disabled = false,
}) => {
    const range = maxValue - minValue;
    const rawPercent = range > 0
        ? Math.min(Math.max((((value - minValue) / range) * 100), 0), 100)
        : 0;

    const percent = Number(rawPercent.toFixed(2));

    return (
        <div className="progress-range-slider">
            <fieldset className="slider-container">
                <input
                    type="range"
                    id="progress-input-slider"
                    className={`input-slider ${disabled ? 'disable-slider' : 'active-slider'}`}
                    min={minValue}
                    max={maxValue}
                    step="1"
                    value={value}
                    readOnly
                />
            </fieldset>
            <div className="progress-slider-value">
                <div className="progress-slider-left">
                    <label
                        htmlFor="progress-input-slider"
                        className={`progress-slider-count ${disabled ? 'disable-color' : 'active-color'}`}
                    >
                        {value}
                    </label>
                    {showTarget && (
                        <span className={`progress-slider-unit ${disabled ? 'disable-color' : 'active-color'}`}>
                            /{maxValue}
                        </span>
                    )}
                    {unit && (
                        <span className={`progress-slider-unit ${disabled ? 'disable-color' : 'active-color'}`}>
                            {' '}{unit}
                        </span>
                    )}
                </div>
                {showPercent && (
                    <span className={`progress-slider-percent ${disabled ? 'disable-color' : ''}`}>
                        {percent}%
                    </span>
                )}
            </div>
        </div>
    )
}

export default ProgressBar;